// extracted by mini-css-extract-plugin
module.exports = {"back":"VehicleSelection_back__30GSf","root":"VehicleSelection_root__2zmY6","spotLink":"VehicleSelection_spotLink__LOY7X","vehicle":"VehicleSelection_vehicle__1xJeF"};